import i18n from '@/i18n'
import AttrHorizontal from './attr_horizontal'
import AttrVertical from './attr_vertical'
import { pickBy } from '@/utils'

export default {
  name: 'marquees',
  setting: [
    { label: i18n.t('wgt_marquees.config.149641-0'), key: 'title', component: 'input', value: i18n.t('wgt_marquees.config.149641-0') },
    { label: i18n.t('wgt_marquees.config.149641-1'), key: 'subtitle', component: 'input', value: i18n.t('wgt_marquees.config.149641-1') },
    { label: i18n.t('wgt_marquees.config.149641-2'), key: 'padded', component: 'switch', value: true },
    {
      label: i18n.t('wgt_marquees.config.149641-3'),
      key: 'direction',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_marquees.config.149641-4'), label: 'vertical' },
        { name: i18n.t('wgt_marquees.config.149641-5'), label: 'horizontal' }
      ],
      value: 'vertical'
    },
    { label: i18n.t('wgt_marquees.config.149641-6'), key: 'bgcolor', component: 'color', value: '#ffffff' },
    { label: i18n.t('wgt_marquees.config.149641-7'), key: 'fontcolor', component: 'color', value: '#000000' },
    {
      label: i18n.t('wgt_marquees.config.149641-5'),
      key: 'dataText',
      isShow: function () {
        return this.value.direction == 'horizontal'
      },
      component: function (h, { key }) {
        return <AttrHorizontal v-model={this.value[key]} />
      },
      value: [{ title: i18n.t('wgt_marquees.config.149641-8') }]
    },
    {
      label: i18n.t('wgt_marquees.config.149641-4'),
      key: 'dataContent',
      isShow: function () {
        return this.value.direction == 'vertical'
      },
      component: function (h, { key }) {
        return <AttrVertical v-model={this.value[key]} />
      },
      value: [{ title: i18n.t('wgt_marquees.config.149641-9'), id: '' }]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    let res = {
      name,
      ...base,
      ...config
    }
    if (config.direction == 'horizontal') {
      res = {
        ...res,
        dataText: data
      }
    } else {
      res = {
        ...res,
        dataContent: data
      }
    }
    return res

    // dataText: config.direction == 'horizontal' ? data : [{ title: i18n.t('wgt_marquees.config.149641-8') }],
    //   dataContent: config.direction == 'vertical' ? data : [{ title: i18n.t('wgt_marquees.config.149641-9'), id: '' }]
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          bgcolor: 'bgcolor',
          direction: 'direction',
          fontcolor: 'fontcolor'
        })
      },
      data: v.direction == 'horizontal' ? v.dataText : v.dataContent
    })
  }
}
